const userSettings = globalThis.reservationGlobals ?? {};

const settings = /** @type const */ ({
  confirmationTimeLimitMinutes: userSettings.confirmationTimeLimitMinutes ?? 5,
  locationExpiryDays: userSettings.locationExpiryDays ?? 30,
  locationKey: userSettings.locationKey ?? "moxies_location",
  defaultReservationHour: userSettings.defaultReservationHour ?? 19,
  wpApiHost: userSettings.wpApiHost ?? "",
  // OpenTable
  otQueryTimesUrl: userSettings.otQueryTimesUrl,
  otLockReservationUrl: userSettings.otLockReservationUrl,
  otCreateReservationUrl: userSettings.otCreateReservationUrl,
  otExperiencesUrl: userSettings.otExperiencesUrl,
  // SVG Icon Paths
  svgArrowIcon: userSettings.svgArrowIcon,
  svgCalendarIcon: userSettings.svgCalendarIcon,
  svgMenuIcon: userSettings.svgMenuIcon,
  svgPeopleIcon: userSettings.svgPeopleIcon,
  svgTimeIcon: userSettings.svgTimeIcon,
});

export default settings;
